/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable-next-line no-unused-vars */
import { Route, Routes } from 'react-router-dom';

import LandingPage from 'pages/LandingPage';
import ProjectPage from 'pages/ProjectPage';
import NotFoundPage from 'pages/NotFoundPage';
import AboutPage from 'pages/AboutPage';
import CareerPage from 'pages/CareerPage';
import ProductsPage from 'pages/ProductsPage';
import ProductDetailPage from 'pages/ProductDetailPage';

import { ProjectDetailPage } from 'pages/ProjectDetailPage';
import { DiscussProjectPage } from 'pages/DiscussProjectPage';

import './assets/css/styles.css';

function App() {
  return (
    <>
      <Routes>
    <Route exact path="/" element={<LandingPage />} />
    <Route path="/project" element={<ProjectPage />} />
    <Route exact path="/project/:id" element={<ProjectDetailPage />} />
    <Route path="/products" element={<ProductsPage />} />
    <Route exact path="/product/:id" element={<ProductDetailPage />} />
    <Route exact path="/about" element={<AboutPage />} />
    <Route exact path="/career" element={<CareerPage />} />
    <Route exact path="/discuss-project" element={<DiscussProjectPage />} />
        <Route path="**" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}

export default App;
